import auth from './auth';
import user from './user';
import organization from './organization';
import uom from './uom';
import currency from './currency';
import category from './category';
import attribute from './attribute';

export default {
  auth,
  user,
  organization,
  uom,
  currency,
  category,
  attribute,
};



// WEBPACK FOOTER //
// ./src/store/modules/core/index.js